export default __webpack_public_path__ + "static/media/babymilestoneImg2.3fc712b2.png";